import { __awaiter, __generator } from "tslib";
import { addProp, body } from "@pnp/odata";
import { _Web, Web } from "../webs/types.js";
import { SiteUsers, SiteUser } from "./types.js";
import { odataUrlFrom } from "../odata.js";
import { spPost } from "../operations.js";
addProp(_Web, "siteUsers", SiteUsers);
addProp(_Web, "currentUser", SiteUser, "currentuser");
_Web.prototype.ensureUser = function (logonName) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, spPost(this.clone(Web, "ensureuser"), body({ logonName: logonName }))];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, {
                            data: data,
                            user: SiteUser(odataUrlFrom(data)),
                        }];
            }
        });
    });
};
_Web.prototype.getUserById = function (id) {
    return SiteUser(this, "getUserById(" + id + ")");
};
